import classNames from "classnames/dedupe";
import React, { useCallback } from "react";
import { Link } from "../../ActionsSelectors/Link";
import { IABCNavItem } from "./ABCTool.interface";

function ABCNavItem({
  id,
  text,
  active,
  disabled,
  isDot,
  children,
  onSelect,
  ...link
}: IABCNavItem) {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      onSelect?.(id, e);
    },
    [id, onSelect],
  );

  return (
    <li
      className={classNames("abc-nav__li", {
        "abc-nav__li--dot": isDot,
      })}
      data-testid="abc-navItem-component"
    >
      <Link
        classes={{
          root: classNames("abc-nav__a", {
            "abc-nav__a--active": active,
            "abc-nav__a--disabled": disabled,
          }),
        }}
        text={text}
        onClick={handleClick}
        {...link}
      >
        {children as string}
      </Link>
    </li>
  );
}

export default ABCNavItem;
